import { Component, Input, Output, AfterViewInit, OnChanges, SimpleChanges, ViewChild, ElementRef, EventEmitter } from '@angular/core';
import { BaseComponent } from '@portals/core';

@Component({
	selector: 'portals-video-player',
	templateUrl: './video-player.component.html',
	styleUrls: ['./video-player.component.scss'],
})
export class VideoPlayerComponent extends BaseComponent implements AfterViewInit, OnChanges {
	@ViewChild('video', { static: true }) videoRef!: ElementRef;
	@Input() autoplay = false;
	@Input() controls = true;
	@Input() videoUrl?: string;
	@Input() videoSubtitleUrl!: string;
	@Input() videoPosterUrl: string | any = '' || 'assets/images/video-thumb-large.png';
	@Input() videoHeight: any;
	@Output() playingHeight = new EventEmitter();
	videoMaxHeight: string = 'auto';
	url = 'https://dash.akamaized.net/envivio/Envivio-dash2/manifest.mpd';

	constructor() {
		super();
	}

	ngOnChanges(changes: SimpleChanges) {
		// console.log(changes)
		if (!changes.firstChange) {
			// console.log(this.videoRef, changes.previousValue, changes.currentValue)
			const videoElement: HTMLVideoElement = this.videoRef.nativeElement;
			if (!videoElement.paused) {
				// console.log('Video is playing');
				videoElement.pause();
				videoElement.load();
				videoElement.currentTime = 0;
				this.playingHeight.emit(-100);
			}
		}
	}

	ngAfterViewInit() {
		this.videoMaxHeight = this.videoHeight ? this.videoHeight + 'px' : 'auto';
	}

	onPlayClick() {
		const videoElement: HTMLVideoElement = this.videoRef.nativeElement;
		// videoElement.requestFullscreen();
		this.playingHeight.emit(videoElement.offsetHeight);
	}
	onEndVideo() {
		const videoElement: HTMLVideoElement = this.videoRef.nativeElement;
		videoElement.load();
		this.playingHeight.emit(videoElement.offsetHeight);
	}
}
